const { isDefaultLanguage } = require('./localeHelpers');
const { getSportdogPageTitle } = require('./getSportdogPageTitle');
const {
  getLanguagesGroupedByRegion,
} = require('./getLanguagesGroupedByRegion');
const {
  getAllowedLanguages,
  getAllowedLanguagesForPage,
} = require('./getAllowedLanguages');

module.exports = {
  getAllowedLanguages,
  getAllowedLanguagesForPage,
  getLanguagesGroupedByRegion,
  isDefaultLanguage,
  getSportdogPageTitle,
};
